import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const qwGray500 = '#444';
const qwRed = '#ff0000';
const black = '#000';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

export const StripeProvider = ({ children }) => {
  const options = {
    locale: 'en',
    appearance: {
      rules: {
        '.Input': {
          fontSize: '1.25rem',
          lineHeight: '1.375rem',
          padding: '0.125rem',
          borderRadius: '0.1875rem',
          borderColor: qwGray500,
          boxShadow: 'none',
        },
        '.Input--invalid': {
          borderWidth: '1px',
          borderColor: qwRed,
          boxShadow: 'none',
        },
        '.Label': {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          margin: '0',
          color: black,
        },
        '.Error': {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          margin: '0',
          color: qwRed,
        },
      },
    },
  };
  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};
